import styled from "styled-components";

export const Checkbox = styled.input`
	outline-color: ${(props) => props.theme.colours.primary};
	margin-left: 12px;
`;
